import { Controller } from "@hotwired/stimulus"

// Support admin tag form: hide the department picker while "global" is checked.
//
// A global tag reaches EVERY department, so its departments are not what grants
// it reach — picking one would not narrow anything, and showing the picker would
// imply otherwise. The rows are kept on save as the backfill's scope hint (see
// SupportTags::AttributeNormalizer); hiding the picker keeps the admin from
// editing a field that has no effect while the tag is global, without the server
// discarding anything.
export default class extends Controller {
  static targets = ["global", "departments"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasDepartmentsTarget || !this.hasGlobalTarget) return

    this.departmentsTarget.hidden = this.globalTarget.checked
  }
}
